import axios from "axios";

export default axios.create({
  baseURL: "https://api.unsplash.com",
  headers: {
    Authorization:
      "Client-ID 406ac5767fcde68454a6acc6542e588a78242dcbdcddce54a0411455263deb60"
  }
});
